;(function(){
  const bbSwiperGalleries = document.querySelectorAll(".bb-swiper-gallery")
  bbSwiperGalleries.forEach(this_ => {
    const gallerySwiper = this_.querySelector('.bb-swiper-gallery-content')
    const gallerySwiperScrollbar = this_.querySelector('.swiper-scrollbar')

    init()

    window.addEventListener('resize', init)

    function init() {
      const count = window.innerWidth >= 960 ? this_.getAttribute('data-show-count-pc') : this_.getAttribute('data-show-count-m')
      const showCount = parseInt(count) / 100
      new Swiper(gallerySwiper, {
        slidesPerView: showCount,
        grid: {
            fill: 'row',
            rows: 1,
        },
        scrollbar: {
            el: gallerySwiperScrollbar,
        },
      })
    }
  })
})()